import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  ButtonWithAction,
  Paragraph,
  Box,
  Cluster,
  Stack,
  Center,
  withWindowSize,
  Title,
} from '@thecb/components';

const NotFound = () => {
  const navigate = useNavigate();
  const { isMobile } = useContext(ThemeContext);
  return (
    <Cluster justify="center" align="center" style={{ height: '100%' }}>
      <Box>
        <Stack>
          <Box padding="0">
            <img
              src="/img/404.svg"
              width={isMobile ? '100%' : '460px'}
              height="auto"
            />
          </Box>
          <Box padding="0">
            <Title textAlign="center">Oops!</Title>
            <Title as="h5" textAlign="center">
              Where did we go?
            </Title>
          </Box>
          <Center singleChild>
            <Box padding="0">
              <Paragraph textAlign="center">
                The requested url was not found.
              </Paragraph>
              <Paragraph textAlign="center">
                Please return to the home page.
              </Paragraph>
            </Box>
          </Center>
          <Center singleChild>
            <Box padding="1rem 0">
              <ButtonWithAction text="Go Back" action={() => navigate('/')} />
            </Box>
          </Center>
        </Stack>
      </Box>
    </Cluster>
  );
};

export default withWindowSize(NotFound);
